import { Component, Input, OnChanges } from '@angular/core';
import { LeaveGroup } from './workforce.types';

@Component({
  selector: 'app-leave-summary-table',
  standalone: false,
  template: `
    <div class="table-container">
      <div class="chart-title table-title">Leave Summary by {{ groupLabel }}
        <app-info-tooltip placement="below" text="Estimated capacity, accepted leave used and estimated remaining days for each group."></app-info-tooltip>
      </div>
      <p class="table-caption">Groups with fewer than 5 employees at period end are excluded. Sorted by leave used.</p>
      <p *ngIf="!sortedRows.length">No groups meet the reporting criteria for this selection.</p>
      <table *ngIf="sortedRows.length">
        <thead><tr>
          <th>{{ groupLabel }} <app-info-tooltip placement="below" text="The selected department, business or company grouping."></app-info-tooltip></th>
          <th>Employees <app-info-tooltip placement="below" text="Employees working at the end of the selected period."></app-info-tooltip></th>
          <th>Estimated Capacity (Days) <app-info-tooltip placement="below" text="Estimated at 2.5 days per average employee per month. This is not an actual leave balance."></app-info-tooltip></th>
          <th>Leave Used (Days) <app-info-tooltip placement="below" text="Accepted recorded days, adjusted for employment dates, for leaves overlapping this period. All recorded leave types are included."></app-info-tooltip></th>
          <th>Estimated Remaining (Days) <app-info-tooltip placement="below" text="Estimated capacity minus leave used. A negative number means usage exceeds the estimate."></app-info-tooltip></th>
        </tr></thead>
        <tbody><tr *ngFor="let row of sortedRows">
          <td>{{ row.department }}</td><td>{{ row.employeeCount }}</td>
          <td>{{ row.estimatedLeaveCapacity == null ? 'NIL' : (row.estimatedLeaveCapacity | number:'1.0-2') }}</td>
          <td>{{ row.totalLeaveDays | number:'1.0-2' }}</td>
          <td>{{ row.estimatedLeaveRemaining == null ? 'NIL' : (row.estimatedLeaveRemaining | number:'1.0-2') }}
            <app-info-tooltip *ngIf="row.estimatedLeaveRemaining != null && row.estimatedLeaveRemaining < 0" placement="below" text="Usage exceeds estimated capacity."></app-info-tooltip>
          </td>
        </tr></tbody>
      </table>
    </div>`,
})
export class LeaveSummaryTableComponent implements OnChanges {
  @Input() rows: LeaveGroup[] = [];
  @Input() groupLabel = 'Department';
  sortedRows: LeaveGroup[] = [];

  ngOnChanges(): void {
    this.sortedRows = [...this.rows].sort((a, b) => b.totalLeaveDays - a.totalLeaveDays || a.department.localeCompare(b.department));
  }
}
